import React from 'react';
import { OrderStatus } from '../types/order/orderStatus';

export interface OrderStatusContextProps {
  orderStatuses: Map<string, OrderStatus>;
  setOrderStatuses: (orderStatuses: Map<string, OrderStatus>) => void;
  orderStatusesLoading: boolean;
}

const defaultContext: OrderStatusContextProps = {
  orderStatuses: new Map(),
  setOrderStatuses: () => {},
  orderStatusesLoading: false,
};

export const OrderStatusContext = React.createContext<OrderStatusContextProps>(defaultContext);
